import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button } from '../../flayr-components/Button/Button';

interface IErrorMsgProps {
  message?: React.ReactNode;
  className?: string;
  cta?: boolean;
  ctaLabel?: string;
  onCtaClick?: (e?: any) => void;
}

const ErrorMsg: React.FC<React.PropsWithChildren<IErrorMsgProps>> = ({
  message,
  className,
  cta,
  ctaLabel = 'Close',
  onCtaClick,
}) => {
  return (
    <div className={`py-2 ${className}`}>
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        className="block mx-auto mb-4 text-5xl leading-tight text-red-500"
      />

      <div className="text-center">{message}</div>

      {cta && (
        <div className="mt-8">
          <Button onClick={onCtaClick} size="lg" color="dark" block>
            {ctaLabel}
          </Button>
        </div>
      )}
    </div>
  );
};
export default ErrorMsg;
